<mat-dialog-content class="mat-typography" [style]="data.length < 3?'display: flex;':''" style='align-items: center; justify-content:center;'>

    <div [style]="data.length < 3?'justify-content: space-around;':''"  style='display: flex; flex-wrap:wrap; width: 100%;'>

        <div *ngFor="let item of data"  class="container-icon">
            <div class='icon-menu'>
                <div  [style.background-color]="item.color" class="icon mat-elevation-z6" matRipple (click)='redirigir(item.route)'>
                    <i class="fa iconFa" [ngClass]="item.icon" [style.color]="item.colorIcon"></i>
                </div>
                <div class="mt-1">
                    <h3 class="line">{{item.name}}</h3>
                </div>
            </div>
        </div>
    </div>


  </mat-dialog-content>
